<template>
<div
  id="app"
  class="bg-grey-200"
>
  <div class="main-container">
    <main-nav/>
    <install
      v-if="bannerEnabled"
      @install="onInstallBanner"
      @close="onCloseBanner"
    />
  </div>
</div>
</template>

<script>

import playersStore from './store/PlayersStore'
import gamesStore from './store/GamesStore'
import MainNav from './components/MainNav.vue'
import Install from './components/Install.vue'

export default {
  name: 'app',
  components: {
    'main-nav': MainNav,
    'install': Install,
  },
  data() {
    return {
      playersState: playersStore.state,
      gamesState: gamesStore.state,
      bannerEnabled: false,
    }
  },
  created() {
    this.deferredPrompt = null
    window.addEventListener('beforeinstallprompt', e => {
      e.preventDefault()
      this.deferredPrompt = e
      this.bannerEnabled = true
    })
  },
  methods: {
    onCloseBanner() { this.bannerEnabled = false },
    onInstallBanner() {
      this.bannerEnabled = false
      if (!this.deferredPrompt) return
      this.deferredPrompt.prompt()
      this.deferredPrompt.userChoice.then(choiceResult => {
        if (choiceResult.outcome === 'accepted') {
          // alert('User accepted the A2HS prompt');
        } else {
          // alert('User dismissed the A2HS prompt');
        }
        this.deferredPrompt = null;
      })
    },
  },
  watch: {
    playersState: {
      handler: value => { playersStore.pushLocalStorage() },
      deep: true
    },
    gamesState: {
      handler: value => { gamesStore.pushLocalStorage() },
      deep: true
    },
  },
}
</script>

<style lang="stylus">

@import 'styles/material'
@import 'styles/common'

html,
body
  height 100%
  overscroll-behavior-y contain

#app
  width 100%
  height 100%

.main-container
  max-width 320px
  max-height 1000px
  height 100%
  margin auto
  overflow-y hidden
  @media screen and (max-width: 800px)
    max-width 100%
    max-height 100%
    width 100%

p, h1, h2, h3
  padding 0
  margin 0
  line-height normal

</style>


// WEBPACK FOOTER //
// App.vue?b4c6f204